import { handleActions } from 'redux-actions';

import { feedbackActions } from '../actions/feedback';

export const {
  feedbackRequest,
  feedbackRequestSucceeded,
  feedbackRequestFailed,
} = feedbackActions;

type StateT = {
  meta: any;
};

const initialState: StateT = {
  meta: {
    asyncStatus: 'succeeded',
  },
};

const feedback = handleActions<StateT, any>(
  {
    [feedbackRequest.toString()]: (state: StateT) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },
    [feedbackRequestSucceeded.toString()]: (state: StateT) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'succeeded' } };
    },
    [feedbackRequestFailed.toString()]: (state: StateT) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },
  },
  initialState,
);

export default feedback;
